<template>
  <div class="detialTxt px-1">
    <div  class='title' style="font-weight:bold;" >{{featureInfo.featureName}}</div>
    <div class="txt" style="font-size:16px; line-height:28px; margin-top:10px" v-html="featureInfo.featureContent"></div>
  </div>
</template>

<script>
export default {
  name: "DetailTxt",
  props: ["featureInfo"]
};
</script>


<style lang="less" >
.detialTxt {
    h1 {
      font-size: 0.9rem;
    }
    h2 {
      font-size: 0.7rem;
    }
    h3 {
      font-size: 0.5rem;
    }
    h4 {
      font-size: 0.4rem;
    }
    h5 {
      font-size: 0.35rem;
    }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .detialTxt {
    width: 100%;
    float: left;
    font-size: 16px;
    // font-family: Calibri;
    .title {
      font-size: 0.5rem;
      font-family: FranklinGothic-Demi;
      font-weight: 400;
      color: #2f2f2f;
      line-height: 1.5;
      font-weight: bold;
    }
    .txt {
      // padding-top: 10px;
      font-size: 0.4rem;
      font-family: Open Sans;
      font-weight: 400;
      line-height: 0.7rem;
      padding: 0px 0 15px 0;
      // word-break:break-all;
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      .h1,
      .h2,
      .h3,
      .h4,
      .h5,
      .h6 {
        font-size: 0.6rem !important;
      }
      p {
        margin-top: 10px !important;
        span {
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
            "Helvetica Neue", Arial, "Noto Sans", sans-serif,
            "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
            "Noto Color Emoji";
        }
      }
      img {
        width: 100% !important;
        height: auto !important;
      }
    }
  }
}
@media screen and (min-width: 768px) {
  .detialTxt {
    width: 100%;
    font-size: 48px;
    float: left;
    .txt {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      .h1,
      .h2,
      .h3,
      .h4,
      .h5,
      .h6 {
        font-size: 0.6rem !important;
      }
    }
  }
}
</style>